/* eslint-disable  */
import React, { useState,useEffect} from "react";
import { TextField, Button, Container, Stack,SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Box from '@mui/material/Box';
import {get}  from '../library/Api';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import {post,put} from '../library/Api';
import { useLocation } from "react-router-dom";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";


const EditvehicleForm = ({vehicle_form_data ,onClosetab}) => {
  console.log("veicle page ");

  const[customerId,setCustomerId] = useState('')
  const[vehicleId,setVehicleId] = useState('')
  const [Name, setFirstName] = useState("");
  const [company, setCompany] = useState("");
  const [noOfVehicle,setNoOfVehicle] = useState("0")

  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [plate, setplate] = useState("");
  const [licensePlateSpaceError, setLicensePlateSpaceError] = useState(false);
  const [color, setColor] = useState("");
  const [state, setState] = useState("TX");
  const [admin_id, setadmin_id] = useState('');

  
  const[addCount,setAddCount] = useState(0);
  const[open,setOpen] = useState(false)
  const [userList, setDatas] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const lcompany = localStorage.getItem("company");

  const location = useLocation();
  const passed_data = location.state || vehicle_form_data;
  // console.log("kjklj",lcompany)
  console.log("--------------------------------yes--->",passed_data);
  console.log("--------------------------------yes--->",vehicle_form_data);
  const states = [
    { label: 'Alabama (AL)', value: 'Alabama', short_name: 'AL' },
    { label: 'ALASKA (AK)', value: 'New York', short_name: 'AK' },
    { label: 'AMERICAN SAMOA (AS)', value: 'AMERICAN SAMOA', short_name: 'AS' },
    { label: 'ARIZONA (AZ)', value: 'ARIZONA', short_name: 'AZ' },
    { label: 'ARKANSAS (AR)', value: 'ARKANSAS', short_name: 'AR' },
    { label: 'CALIFORNIA (CA)', value: 'CALIFORNIA', short_name: 'CA' },
    { label: 'COLORADO (CO)', value: 'COLORADO', short_name: 'CO' },
    { label: 'CONNECTICUT (CT)', value: 'CONNECTICUT', short_name: 'CT' },
    { label: 'DELAWARE (DE)', value: 'DELAWARE', short_name: 'DE' },
    { label: 'DISTRICT OF COLUMBIA (DC)', value: 'DISTRICT OF COLUMBIA', short_name: 'DC' },
    { label: 'FLORIDA (FL)', value: 'FLORIDA', short_name: 'FL' },
    { label: 'GEORGIA (GA)', value: 'GEORGIA', short_name: 'GA' },
    { label: 'GUAM (GU)', value: 'GUAM', short_name: 'GU' },
    { label: 'HAWAII (HI)', value: 'HAWAII', short_name: 'HI' },
    { label: 'IDAHO (ID)', value: 'IDAHO', short_name: 'ID' },
    { label: 'ILLINOIS (IL)', value: 'ILLINOIS', short_name: 'IL' },
    { label: 'INDIANA (IN)', value: 'INDIANA', short_name: 'IN' },
    { label: 'IOWA (IA)', value: 'IOWA', short_name: 'IA' },
    { label: 'KANSAS (KS)', value: 'KANSAS', short_name: 'KS' },
    { label: 'KENTUCKY (KY)', value: 'KENTUCKY', short_name: 'KY' },
    { label: 'LOUISIANA (LA)', value: 'LOUISIANA', short_name: 'LA' },
    { label: 'MAINE (ME)', value: 'MAINE', short_name: 'ME' },
    { label: 'MARYLAND (MD)', value: 'MARYLAND', short_name: 'MD' },
    { label: 'MASSACHUSETTS (MA)', value: 'MASSACHUSETTS', short_name: 'MA' },
    { label: 'MICHIGAN (MI)', value: 'MICHIGAN', short_name: 'MI' },
    { label: 'MINNESOTA (MN)', value: 'MINNESOTA', short_name: 'MN' },
    { label: 'MISSISSIPPI (MS)', value: 'MISSISSIPPI', short_name: 'MS' },
    { label: 'MISSOURI (MO)', value: 'MISSOURI', short_name: 'MO' },
    { label: 'MONTANA (MT)', value: 'MONTANA', short_name: 'MT' },
    { label: 'NEBRASKA (NE)', value: 'NEBRASKA', short_name: 'NE' },
    { label: 'NEVADA (NV)', value: 'NEVADA', short_name: 'NV' },
    { label: 'NEW HAMPSHIRE (NH)', value: 'NEW HAMPSHIRE', short_name: 'NH' },
    { label: 'NEW JERSEY (NJ)', value: 'NEW JERSEY', short_name: 'NJ' },
    { label: 'NEW MEXICO (NM)', value: 'NEW MEXICO', short_name: 'NM' },
    { label: 'NEW YORK (NY)', value: 'NEW YORK', short_name: 'NY' },
    { label: 'NORTH CAROLINA (NC)', value: 'NORTH CAROLINA', short_name: 'NC' },
    { label: 'NORTH DAKOTA (ND)', value: 'NORTH DAKOTA', short_name: 'ND' },
    { label: 'NORTHERN MARIANA IS (MP)', value: 'NORTHERN MARIANA IS', short_name: 'MP' },
    { label: 'OHIO (OH)', value: 'OHIO', short_name: 'OH' },
    { label: 'OKLAHOMA (OK)', value: 'OKLAHOMA', short_name: 'OK' },
    { label: 'OREGON (OR)', value: 'OREGON', short_name: 'OR' },
    { label: 'PENNSYLVANIA (PA)', value: 'PENNSYLVANIA', short_name: 'PA' },
    { label: 'PUERTO RICO (PR)', value: 'PUERTO RICO', short_name: 'PR' },
    { label: 'RHODE ISLAND (RI)', value: 'RHODE ISLAND', short_name: 'RI' },
    { label: 'SOUTH CAROLINA (SC)', value: 'SOUTH CAROLINA', short_name: 'SC' },
    { label: 'SOUTH DAKOTA (SD)', value: 'SOUTH DAKOTA', short_name: 'SD' },
    { label: 'TENNESSEE (TN)', value: 'TENNESSEE', short_name: 'TN' },
    { label: 'TEXAS (TX)', value: 'TEXAS', short_name: 'TX' },
    { label: 'UTAH (UT)', value: 'UTAH', short_name: 'UT' },
    { label: 'VERMONT (VT)', value: 'VERMONT', short_name: 'VT' },
    { label: 'VIRGINIA (VA)', value: 'VIRGINIA', short_name: 'VA' },
    { label: 'VIRGIN ISLANDS (VI)', value: 'VIRGIN ISLANDS', short_name: 'VI' },
    { label: 'WASHINGTON (WA)', value: 'WASHINGTON', short_name: 'WA' },
    { label: 'WEST VIRGINIA (WV)', value: 'WEST VIRGINIA', short_name: 'WV' },
    { label: 'WISCONSIN (WI)', value: 'WISCONSIN', short_name: 'WI' },
    { label: 'WYOMING (WY)', value: 'WYOMING', short_name: 'WY' },
  ];
  const states_old = [{  label: 'Alabama (AL)',  value: 'Alabama'},{  label: 'ALASKA (AK)',   value: 'New York' }, {  label: 'AMERICAN SAMOA (AS)',  value: 'AMERICAN SAMOA'
    }, {   label: 'ARIZONA (AZ)',   value: 'ARIZONA' }, {   label:'ARKANSAS (AR)',   value:'ARKANSAS' },{ label:'CALIFORNIA (CA)', value:'CALIFORNIA'},{label:'COLORADO (CO)', value:'COLORADO' },{ label:'CONNECTICUT (CT)',  value:'CONNECTICUT'},
     { label:' DELAWARE (DE)', value:' DELAWARE' },{   label:'DISTRICT OF COLUMBIA (DC)', value:'DISTRICT OF COLUMBIA' },  {   label:'FLORIDA (FL)',   value:'FLORIDA' }, { label:'GEORGIA (GA)',   value:'GEORGIA'
    }, { label:'GUAM (GU)', value:'GUAM'},{ label:'HAWAII (HI)', value:'HAWAII' }, {   label:'IDAHO (ID)', value:'IDAHO' },{label:'ILLINOIS (IL)',value:'ILLINOIS'}, {  label:'INDIANA (IN)',  value:'INDIANA'},{  label:'IOWA (IA)', value:'IOWA'},
    { label:'KANSAS (KS)', value:'KANSAS'},{ label:'KENTUCKY (KY)', value:'KENTUCKY'},{  label:'LOUISIANA (LA)',  value:'LOUISIANA'},
    { label:'MAINE (ME)', value:'MAINE'},{  label:'MARYLAND (MD)',  value:'MARYLAND' }, {   label:'MASSACHUSETTS (MA)',   value:'MASSACHUSETTS' }, {  label:'MICHIGAN (MI)',value:'MICHIGAN' }, 
    {  label:'MINNESOTA (MN)',  value:'MINNESOTA' }, {  label:'MISSISSIPPI (MS)',  value:'MISSISSIPPI'},{  label:' MISSOURI (MO)',  value:' MISSOURI' },
    { label:'MONTANA (MT)',  value:'MONTANA 	MT' }, { label:'NEBRASKA (NE)', value:'NEBRASKA'},{ label:'NEVADA (NV)',  value:'NEVADA'}, { label:'NEW HAMPSHIRE (NH)', value:'NEW HAMPSHIRE'
    }, { label:'NEW JERSEY (NJ)', value:'NEW JERSEY'},  {label:'NEW MEXICO (NM)', value:'NEW MEXICO' }, { label:'NEW YORK (NY)', value:'NEW YORK'},{ label:'NORTH CAROLINA (NC)',  value:'NORTH CAROLINA'
    }, {  label:'NORTH DAKOTA (ND)',  value:'NORTH DAKOTA 	ND' }, {  label:'NORTHERN MARIANA IS (MP)',  value:'NORTHERN MARIANA IS'},{ label:'OHIO (OH)',      value:'OHIO' },{ label:'OKLAHOMA (OK)',  value:'OKLAHOMA'}, { label:'OREGON (OR)',
      value:'OREGON' }, {label:'PENNSYLVANIA (PA)',  value:'PENNSYLVANIA'}, {  label:'PUERTO RICO (PR)',  value:'PUERTO RICO'}, {  label:'RHODE ISLAND (RI)',  value:'RHODE ISLAND'}, {  label:'SOUTH CAROLINA (SC)',  value:'SOUTH CAROLINA '}, {  label:'SOUTH DAKOTA (SD)',  value:'SOUTH DAKOTA'
    }, { label:'TENNESSEE (TN)',  value:'TENNESSEE'},{  label:'TEXAS (TX)',  value:'TEXAS' },  {   label:'UTAH (UT)',   value:'UTAH'}, {  label:'VERMONT 	(VT)',value:'VERMONT'}, 
    {  label:'VIRGINIA (VA)',  value:'VIRGINIA'},  { label:'VIRGIN ISLANDS (VI)', value:' VIRGIN ISLANDS'},  { label:'WASHINGTON (WA)', value:'WASHINGTON'}, {  label:' WEST VIRGINIA (WV)',   value:' WEST VIRGINIA'}, {     label:' WISCONSIN (WI)',   value:' WISCONSIN' },  {   label:' WYOMING (WY)',   value:' WYOMING' },  ];
  const name = [{ value: 'Neethu', label: 'Neethu'},{  value: 'Hari',  label: 'Hari'},{  value: 'Karthik',  label: 'Karthik'},{  value: 'Dev',  label: 'Dev'}];
  const handleLicensePlateChange = (e) => {
    const { value } = e.target;
    const hasWhitespace = /\s/.test(value);
    const normalized = value.replace(/\s+/g, "");
    setLicensePlateSpaceError(hasWhitespace);
    setplate(normalized);
  };
  const handleLicensePlateKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      setLicensePlateSpaceError(true);
    }
  };
  
   useEffect(() => {
      // Handle backward compatibility: split make_model into make and model
      const make_model = passed_data.make_model || vehicle_form_data?.make_model || "";
      if (make_model) {
        const parts = make_model.trim().split(" ");
        setMake(parts[0] || "");
        setModel(parts.slice(1).join(" ") || parts[0] || "");
      } else {
        setMake("");
        setModel("");
      }
      setFirstName(passed_data.name);
      setCompany(passed_data.company);
      setplate(passed_data.license_plate );
      setColor(passed_data.color)
      setState(passed_data.state);
      setCustomerId(passed_data.customer_id);
      setVehicleId(passed_data.vehicle_id || '');
      console.log("----------------------ola---",plate)

  }, [vehicle_form_data]);

  useEffect(() => {
    var mcdata = JSON.parse(localStorage.getItem("MCData"));
    var tempadmin_id= mcdata.admin_id
    setadmin_id(tempadmin_id)
  }, []);


  const handleCustomerNameChange = (e) =>{
    const new_change = e.target.value
    setFirstName(e.target.value)
  }
  const handleCancel = () => {
   onClosetab()
  }


  const handleAdd = () => {
    setOpen(true)
  }
  
  function vehicleSubmit(event) {
    console.log("s")
  }

  function vehicleHandleSubmit() {
    // event.preventDefault();
    setLoading(true);
   
    // Combine make and model for backward compatibility with EditVehicle API
    const make_model = `${make} ${model}`.trim();
    const data = {
      customer_id :customerId,
      admin_id:admin_id,
      make_model : make_model,
      color :color,
      license_plate :plate,
      state :state,
      // parking_spot :parking,
      vehicle_id :vehicleId,
      company :company
    }

    // console.log("--------->",data)
    console.log("-----sas---------------->",customerId,color,plate,make,model)
    console.log("------------------------",plate,company,state)
    if (customerId && color && plate && make && model && company && state ) {
      console.log("All fields have values");
      // post("insert_vehicledata", data)
      post("edit_vehicledata", data)
      // put(`edit_vehicledata/${vehicleId}`,data)
            .then((response) => {
              // console.log("data", response.data.message);
              if (response.status === 200) {
                toast.success(response.data.message);
                setLoading(false);
                setTimeout(() => {
                    // Code to execute after 2 seconds
                    console.log('Timer finished!');
                    const formcount = Number(addCount)+1
                    setAddCount(formcount)
                    console.log("addCount = ",addCount)
                    console.log("no of Vehicle = ",noOfVehicle)
                    setOpen(false)
                    if (formcount == Number(noOfVehicle)){
                      navigate("/registers")
                    }
                    // navigate(-1)
                  }, 2000);
                  onClosetab()
              }
              else {
                toast.error(`Failed to add vehicle`);

              }
            }, (error) => {
              toast.error('Error While Updating', {
                autoClose: 3000,
              });
            }
            );

    } else {
      console.log("Some fields are empty or undefined");
    }
  }

  return (
    <React.Fragment>
      <ToastContainer/>
        <Box sx={{ display: 'flex' }}>
 
    <Box component="main" sx={{ flexGrow: 1, p: 3 }} className="mt-0">
    <div className="col-lg-10 m-auto" >
        {/* <h3 className="heading-style mb-4">Edit Vehicle Details</h3> */}
        <form onSubmit={vehicleSubmit} action={<Link to="/login" />}>
         

               {/* <TextField
                  fullWidth
                  label="Company"
                  name="name"
                  disabled
                  onChange={(e) => setCompany(e.target.value)}
                  required
                  // select
                  value={company}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  sx={{ mb: 2 }}
                //   value={values.state}
                >
                 
                </TextField> */}

        
       
          <br />

          {/* <Stack spacing={4} direction="row" sx={{ marginBottom: 2 }} className="mb-0">  */}
          <TextField
              type="text"
              variant="outlined"
              color="secondary"
              label="Make"
              onChange={(e) => setMake(e.target.value)}
              value={make}
              fullWidth
              InputLabelProps={{ shrink: true }}
              required
              className="me-4"
              sx={{ mb: 2 }}
            />
          <TextField
              type="text"
              variant="outlined"
              color="secondary"
              label="Model"
              onChange={(e) => setModel(e.target.value)}
              value={model}
              fullWidth
              InputLabelProps={{ shrink: true }}
              required
              // className="me-4"
              sx={{ mb: 2 }}
            />
            
         
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="License Plate"
            onChange={handleLicensePlateChange}
            onKeyDown={handleLicensePlateKeyDown}
            value={plate}
            fullWidth
            InputLabelProps={{ shrink: true }}
            required
            error={licensePlateSpaceError}
            helperText={
              licensePlateSpaceError ? "Spaces are not allowed in License Plate." : ""
            }
            inputProps={{ maxLength: 25 }}
            sx={{ mb: 2 }}
            className="me-4"
          />

          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Colour"
            onChange={(e) => setColor(e.target.value)}
            value={color}
            InputLabelProps={{ shrink: true }}
            fullWidth
            required
            inputProps={{ maxLength: 25 }}
            sx={{ mb: 2 }}
            // className="me-4"
          />
               <TextField
                  fullWidth
                  label="State"
                  name="state"
                  onChange={(e) => setState(e.target.value)}
                  required
                  select
                  value={state}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  sx={{ mb: 2 }}
                //   value={values.state}
                > 

                <option key = '0'value="">Please select</option>
                <option key = '230'value="TX"> TX </option>
                  {states.map((option) => (
                    <option
                      key={option.value}
                      value={option.short_name}
                    >
                      {option.short_name}
                    </option>
                  ))}
                </TextField>   
                <br /> <br />
           
                   
                    <div className="text-end">
          <Button variant="contained" color="primary" onClick={vehicleHandleSubmit} size="large" className="me-4 py-1  btn-sty text-capitalize">
            Update
          </Button>
          
          <Button variant="contained" color="error"  onClick={handleCancel} size="large" className="py-1 btn-sty text-capitalize">Cancel</Button>
          </div>
         
          <br />
          
        </form>
       
        
        </div>
           
           </Box>
     </Box>
    </React.Fragment>
  );
};

export default EditvehicleForm;
